import React, { SVGProps } from 'react'

/**
 * Feature-local "add to wallet" glyph for the ••• actions menu (matches the
 * design prototype). Lives here rather than in src/components/Svgs, which
 * `gen-svg-components` wipes and regenerates from src/assets/svgs — this has no
 * source asset.
 */
const SvgAddToWallet = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M2.5 6.5h11a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z M2.5 6.5V5.2a1 1 0 0 1 1-1h8.2a1 1 0 0 1 .9.55L14 6.5 M11.5 10h3.5v2.5h-3.5a1.25 1.25 0 0 1 0-2.5Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgAddToWallet
